// MeasurementSystem related
export var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem["METRIC"] = "METRIC";
    MeasurementSystem["IMPERIAL"] = "IMPERIAL";
})(MeasurementSystem || (MeasurementSystem = {}));
export var AreaUnitApiValue;
(function (AreaUnitApiValue) {
    AreaUnitApiValue["M2"] = "M2";
    AreaUnitApiValue["FT2"] = "FT2";
})(AreaUnitApiValue || (AreaUnitApiValue = {}));
export var TemperatureUnitApiValue;
(function (TemperatureUnitApiValue) {
    TemperatureUnitApiValue["CELSIUS"] = "CELSIUS";
    TemperatureUnitApiValue["FAHRENHEIT"] = "FAHRENHEIT";
})(TemperatureUnitApiValue || (TemperatureUnitApiValue = {}));
export var MeasurementSystemLabel;
(function (MeasurementSystemLabel) {
    MeasurementSystemLabel["METRIC"] = "Metric";
    MeasurementSystemLabel["IMPERIAL"] = "Imperial";
})(MeasurementSystemLabel || (MeasurementSystemLabel = {}));
export var TemperatureUnitLabels;
(function (TemperatureUnitLabels) {
    TemperatureUnitLabels["CELSIUS"] = "Celsius";
    TemperatureUnitLabels["FAHRENHEIT"] = "Fahrenheit";
})(TemperatureUnitLabels || (TemperatureUnitLabels = {}));
export var AreaUnitLabels;
(function (AreaUnitLabels) {
    AreaUnitLabels["M2"] = "m\u00B2";
    AreaUnitLabels["FT2"] = "ft\u00B2";
})(AreaUnitLabels || (AreaUnitLabels = {}));
export var TemperatureUnit;
(function (TemperatureUnit) {
    TemperatureUnit["F"] = "\u00B0F";
    TemperatureUnit["C"] = "\u00B0C";
})(TemperatureUnit || (TemperatureUnit = {}));
export const MapTemperatureUnitApiValuesToDisplayUnit = {
    [TemperatureUnitApiValue.CELSIUS]: TemperatureUnit.C,
    [TemperatureUnitApiValue.FAHRENHEIT]: TemperatureUnit.F,
};
export var MeasurementSystemToTemperatureLabel;
(function (MeasurementSystemToTemperatureLabel) {
    MeasurementSystemToTemperatureLabel["METRIC"] = "Celsius";
    MeasurementSystemToTemperatureLabel["IMPERIAL"] = "Fahrenheit";
})(MeasurementSystemToTemperatureLabel || (MeasurementSystemToTemperatureLabel = {}));
export const MapMeasurementSystemToTemperatureUnit = {
    [MeasurementSystem.IMPERIAL]: TemperatureUnit.F,
    [MeasurementSystem.METRIC]: TemperatureUnit.C,
};
export const MapMeasurementSystemToAreaUnit = {
    [MeasurementSystem.IMPERIAL]: AreaUnitLabels.FT2,
    [MeasurementSystem.METRIC]: AreaUnitLabels.M2,
};
// End MeasurementSystem related
// Date/Time format related
export var DateFormat;
(function (DateFormat) {
    DateFormat["MM_DD_YYYY"] = "MM_DD_YYYY";
    DateFormat["DD_MM_YYYY"] = "DD_MM_YYYY";
})(DateFormat || (DateFormat = {}));
export var TimeFormat;
(function (TimeFormat) {
    TimeFormat["HOUR_12"] = "HOUR_12";
    TimeFormat["HOUR_24"] = "HOUR_24";
})(TimeFormat || (TimeFormat = {}));
export var DateFormatLabel;
(function (DateFormatLabel) {
    DateFormatLabel["MM_DD_YYYY"] = "MM/DD/YYYY";
    DateFormatLabel["DD_MM_YYYY"] = "DD/MM/YYYY";
})(DateFormatLabel || (DateFormatLabel = {}));
export var TimeFormatLabel;
(function (TimeFormatLabel) {
    TimeFormatLabel["HOUR_12"] = "AM/PM";
    TimeFormatLabel["HOUR_24"] = "24 Hour";
})(TimeFormatLabel || (TimeFormatLabel = {}));
export var MapDateFormat;
(function (MapDateFormat) {
    MapDateFormat["MM_DD_YYYY"] = "MM/dd/yyyy";
    MapDateFormat["DD_MM_YYYY"] = "dd/MM/yyyy";
})(MapDateFormat || (MapDateFormat = {}));
export var MapTimeFormat;
(function (MapTimeFormat) {
    MapTimeFormat["HOUR_12"] = "h:mm a";
    MapTimeFormat["HOUR_24"] = "HH:mm";
})(MapTimeFormat || (MapTimeFormat = {}));
export var MapFullTimeFormat;
(function (MapFullTimeFormat) {
    MapFullTimeFormat["HOUR_12"] = "h:mm:ss a";
    MapFullTimeFormat["HOUR_24"] = "HH:mm:ss";
})(MapFullTimeFormat || (MapFullTimeFormat = {}));
export const IsoDateFormat = 'yyyy-MM-dd';
// End Date/Time format related
// Locale related
export const defaultLocale = {
    measurementSystem: MeasurementSystem.IMPERIAL,
    dateFormat: MapDateFormat[DateFormat.MM_DD_YYYY],
    timeFormat: MapTimeFormat[TimeFormat.HOUR_12],
    dateTimeFormat: `${MapDateFormat[DateFormat.MM_DD_YYYY]} ${MapTimeFormat[TimeFormat.HOUR_12]}`,
    fullTimeFormat: MapFullTimeFormat[TimeFormat.HOUR_12],
    fullDateTimeFormat: `${MapDateFormat[DateFormat.MM_DD_YYYY]} ${MapFullTimeFormat[TimeFormat.HOUR_12]}`,
};
